/*
 * @Autor: xx
 * @Version: 1.0
 * @Date: 2020-05-20 14:39:10
 * @LastEditors: xx
 * @Description:
 * @LastEditTime: 2020-08-18 09:46:37
 */

import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import store from "../store/index";

// import { objAny, objStr, objNumber } from "../common/common-interface";

// import Home from "../views/home/home.vue";
import Login from "../views/login/login.vue";
import menuList from "../views/sys-manage/system-config/menu-list/menu-list.vue";
// import { objAny } from "@/common/common-interface";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  // {
  //   path: "/",
  //   name: "主页",
  //   component: Home
  // },
  {
    path: "/login",
    name: "登录",
    component: Login,
    meta: {
      full: true
    }
  }
  // {
  //   path: "/homepage/systemconfig/menu-list",
  //   name: "菜单",
  //   component: menuList
  // }
];

const router = new VueRouter({
  // mode: "history",
  base: process.env.BASE_URL,
  routes
});
let timerPage: number;
router.beforeEach((to, from, next) => {
  const state: any = store.state; // eslint-disable-line
  clearTimeout(timerPage);
  timerPage = setTimeout(() => {
    store.commit("SET_PAGELOADING", true);
  }, 100);
  if (to.path != "/login" && !state.sys.isGetRouter) {
    //如果还没有添加路由
    store.dispatch("getRouter", {
      next: next,
      to: to
    });
  } else {
    next();
  }
});
router.afterEach(() => {
  // 动态加载路由页面时给个动画，有时候网不好要几秒钟
  clearTimeout(timerPage);
  store.commit("SET_PAGELOADING", false);
});

export default router;
